var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input-select',{attrs:{"id":"religion","value":_vm.value,"name":"religion","label":"Religion","placeholder":"Any","placeholder-enabled":"","options":[
    { id: 'agnostic', display_label: 'Agnostic' },
    { id: 'atheist', display_label: 'Atheist' },
    { id: 'catholic', display_label: 'Catholic' },
    { id: 'hindu', display_label: 'Hindu' },
    { id: 'jewish', display_label: 'Jewish' },
    { id: 'mormon', display_label: 'Mormon' },
    { id: 'muslim', display_label: 'Muslim' },
    { id: 'protestant', display_label: 'Protestant' },
    { id: 'unaffiliated', display_label: 'Unaffiliated' },
    { id: 'other', display_label: 'Other' }
  ]},on:{"input":function (val) { return _vm.$emit('input', val); }}})}
var staticRenderFns = []

export { render, staticRenderFns }